var _class, _descriptor;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Service from '@ember/service';
import { tracked } from '@glimmer/tracking';
import PrecogSignalExternalService from '@dashboard/junk-drawer/clients/precog-signal-external-service';
import { FetchBySignalTypeRequest } from '@square/dashboard-protos/models/squareup/precog/v2/signals/external';
import { SignalType } from '@square/dashboard-protos/models/squareup/precog/v2/signals/common';
import * as Sentry from '@sentry/ember';
let MerchantSubaudience = (_class = class MerchantSubaudience extends Service {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "subaudience", _descriptor, this);
    _defineProperty(this, "setupPromise", void 0);
  }
  async getSubaudience() {
    try {
      const response = await PrecogSignalExternalService.fetchBySignalType(FetchBySignalTypeRequest.create({
        signalTypes: [SignalType.SIGNAL_SUBAUDIENCE]
      }));
      this.subaudience = response?.subaudience ?? null;
    } catch (e) {
      Sentry.captureException(`Error loading subaudience data: ${e}`);
      this.subaudience = null;
    }
    return this.subaudience;
  }
  async setup() {
    if (!this.setupPromise) {
      this.setupPromise = this.getSubaudience();
      const data = await this.setupPromise;
      return data;
    }
    return this.setupPromise;
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "subaudience", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return null;
  }
}), _class);
export { MerchantSubaudience as default };